export let Code = {
type: `@Component({
    selector: 'p-password',
    template:
        <input type="password" pPassword />
})
export class Password {

}
`,

};


// WEBPACK FOOTER //
// ./src/app/code/password.ts